import { render, staticRenderFns } from "./Sunrise.vue?vue&type=template&id=bb4ad766&scoped=true&"
import script from "./Sunrise.vue?vue&type=script&lang=js&"
export * from "./Sunrise.vue?vue&type=script&lang=js&"
import style0 from "./Sunrise.vue?vue&type=style&index=0&id=bb4ad766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4ad766",
  null
  
)

export default component.exports